import { deleteSectionToUserURL } from "../../../utils/ConstantsURL";

export const useDeleteSection = (token) => {
  const deleteSections = async (userId, documentId, sectionId) => {
    try {
      const response = await fetch(deleteSectionToUserURL(documentId), {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          user_id: userId,
          section_id: sectionId,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Error al eliminar la sección");
      }
    } catch (error) {
      console.error("Error al eliminar la sección:", error.message);
    } finally {
    }
  };

  return { deleteSections };
};
